export function blockLink() {
    return {
        navigate(event) {
            if (!event.target.closest('a')) {
                this.$refs.link.click();
            }
        },
    };
}
